import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AbcUiComponentsModule } from '@barthauer/abc/ui-components';
import { DxGalleryModule } from 'devextreme-angular';
import { AbcCommonEditorsComponent } from './abc-common-editors.component';
import { ChatComponent } from './comments/chat/chat.component';
import { AbcCommentsListComponent } from './comments/list/list.component';
import { DocumentsEditorCardDetailsComponent } from './documents-editor/documents-editor-card/documents-editor-card-details/documents-editor-card-details.component';
import { DocumentsEditorCardComponent } from './documents-editor/documents-editor-card/documents-editor-card.component';
import { DocumentsEditorTableDetailsComponent } from './documents-editor/documents-editor-table/document-editor-table-details/documents-editor-table-details.component';
import { DocumentsEditorTableComponent } from './documents-editor/documents-editor-table/documents-editor-table.component';
import { ImageViewerComponent } from './documents-editor/gallery/imageViewer.component';
import { PropertiesEditorDetailsComponent } from './properties-editor/properties-editor-details/properties-editor-details.component';
import { PropertiesEditorFormComponent } from './properties-editor/properties-editor-form/properties-editor-form.component';
import { PropertiesEditorComponent } from './properties-editor/properties-editor.component';
import { DocumentsListComponent } from './documents-editor/documents-list/documents-list.component';

@NgModule({
  imports: [
    CommonModule,
    AbcUiComponentsModule,
    FlexLayoutModule,
    MatTooltipModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    DxGalleryModule,
    MatInputModule,
    ScrollingModule,
    DocumentsListComponent
  ],
  declarations: [
    AbcCommentsListComponent,
    AbcCommonEditorsComponent,
    DocumentsEditorTableComponent,
    DocumentsEditorTableDetailsComponent,
    PropertiesEditorDetailsComponent,
    PropertiesEditorComponent,
    PropertiesEditorDetailsComponent,
    DocumentsEditorCardComponent,
    DocumentsEditorCardDetailsComponent,
    ChatComponent,
    ImageViewerComponent,
    PropertiesEditorFormComponent,
  ],
  exports: [
    AbcCommentsListComponent,
    AbcCommonEditorsComponent,
    DocumentsEditorTableComponent,
    DocumentsEditorTableDetailsComponent,
    PropertiesEditorDetailsComponent,
    PropertiesEditorComponent,
    DocumentsEditorCardComponent,
    DocumentsEditorCardDetailsComponent,
    ChatComponent,
    PropertiesEditorFormComponent,
    ImageViewerComponent,
  ],
  providers: [DatePipe],
})
export class AbcCommonEditorsModule {}
